export default function onRow() {
  // record, rowIndex
  // return {
  // null
  // style: {cursor: `pointer`},
  // onClick: event => { history.push(`/forms/${record.id}`) }
  // }
}
